import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, Jsonp, URLSearchParams } from '@angular/http';
// import { User } from '../models/user';
import {AppConfig} from '../../app.config';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { Subject }    from 'rxjs/Subject';
@Injectable()
export class AreaManagementService {
    constructor(private http: Http, private config: AppConfig, private _jsonp: Jsonp) { }

    saveAreaManagement(user: any) {
      return this.http.post(this.config.apiUrl +'area/create', user, this.setHeaders()).map((response: Response) => response.json());
    }
    getAllAreaManagement(areaCurrentPage: number, maxSize: any) {
        return this.http.get(this.config.apiUrl +'area/get-all?page='+areaCurrentPage+'&limit='+maxSize, this.setHeaders()).map((response: Response) => response.json());
    }
    getAllActiveAreaManagement(id:any) {
      return this.http.get(this.config.apiUrl + 'area/get-all-active/'+id,this.setHeaders()).map((response:Response) => response.json());
    }
    activeArea(id:any){
        return this.http.post(this.config.apiUrl+'area/active',{id:id},this.setHeaders()).map((response:Response)=> response.json());
    }
    deActiveArea(id:any){
        return this.http.post(this.config.apiUrl+'area/deActive',{id:id},this.setHeaders()).map((response:Response)=> response.json());
    }
    deleteAreaManagement(id: any) {
        // return this.http.post(this.config.apiUrl +'/v1/admin/city/delete-city',{id:id}, this.setHeaders()).map((response: Response) => response.json());
    }
    updateAreaManagement(areaManagement:any) {
        return this.http.put(this.config.apiUrl +'area/update', areaManagement, this.setHeaders()).map((response: Response) => response.json());
    }
    getAreaById(id:any){
        return this.http.post(this.config.apiUrl +'area/find-by-id', {id:id}, this.setHeaders()).map((response: Response) => response.json());
    }
    private setHeaders(params?: any) {
        // create authorization header with jwt token
        let token = localStorage.getItem('token');
        if (token) {
            // console.log('token >>>' + token);
            let headers = new Headers({ 'x-roamingse-token': token });
            if(params)
                return new RequestOptions({ headers: headers , search : params });
            else
                return new RequestOptions({ headers: headers });
        }else{
            return new RequestOptions({});
        }
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/area-management.service.ts